import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ViajesService {
  httpHeaders = new HttpHeaders({
  });
  @Output() asientos: EventEmitter<any> = new EventEmitter();
  @Output() categoria_hotel: EventEmitter<any> = new EventEmitter();  


  constructor(private http: HttpClient) { }

  changeAsientos(data: any) {
    this.asientos.emit(data);
  }

  changeCategoriaHotel(data: any) {
    this.categoria_hotel.emit(data);
  }

  
  createData(nombre: string, descripcion: string, destino: string, dia: string,mes: string, anno: string, salida: string, noches:string, detalles:string, desde:string, hasta:string,
    tipoTransporte: string, asientos: string, hotel: string, estado: string): Observable<any> {
      var fecha = new Date(parseInt(anno), parseInt(mes) - 1, parseInt(dia));
      
      const data: FormData = new FormData();
      data.append("nombre", nombre);
      data.append("descripcion", descripcion);
      data.append("destino", destino);
      data.append("fecha", fecha.toString());
      data.append("salida", salida);
      data.append("noches", noches);
      data.append("desde", desde);
      data.append("hasta", hasta);
      data.append("detalles", detalles);
      data.append("transporte", tipoTransporte);
      data.append("asientos", asientos);
      data.append("hotel", hotel);
      data.append("estado", estado);
               
    const postRequest = new HttpRequest('POST', environment.api + 'api/paquete/create',  data, { 
      headers: this.httpHeaders,
      reportProgress: true,
    }); 
    return this.http.request(postRequest);
  } 
  updateData(id: string, destino: string, dia: string, mes: string, anno: string, salida: string, noches:string, detalles:string, desde:string, hasta:string,
    tipoTransporte: string, asientos: string, hotel: string): Observable<any> {
      var fecha = new Date(parseInt(anno), parseInt(mes)-1, parseInt(dia));      
      const data: FormData = new FormData();
      data.append("id", id);
      data.append("destino", destino);
      data.append("fecha", fecha.toString());
      data.append("salida", salida);
      data.append("noches", noches);
      data.append("desde", desde);
      data.append("hasta", hasta);
      data.append("detalles", detalles);
      data.append("transporte", tipoTransporte);
      data.append("asientos", asientos);
      data.append("hotel", hotel);
               
    const postRequest = new HttpRequest('POST', environment.api + 'api/paquete/update',  data, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  } 

  updateAll(id: string, nombre: string, descripcion:string, destino: string, dia:string,mes: string, anno: string, salida: string, noches:string, detalles:string, desde:string, hasta:string,
    tipoTransporte: string, asientos: string, hotel: string, estado: string): Observable<any> {
      var fecha = new Date(parseInt(anno), parseInt(mes) - 1, parseInt(dia));
      const data: FormData = new FormData();
      data.append("id", id);
      data.append("nombre", nombre);
      data.append("descripcion", descripcion);
      data.append("destino", destino);
      data.append("fecha", fecha.toString());
      data.append("salida", salida);
      data.append("noches", noches);
      data.append("desde", desde);
      data.append("hasta", hasta);
      data.append("detalles", detalles);
      data.append("transporte", tipoTransporte);
      data.append("asientos", asientos);
      data.append("hotel", hotel);
      data.append("estado", estado);
               
    const postRequest = new HttpRequest('POST', environment.api + 'api/paquete/update',  data, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  } 

  updateDescripcion(id: string, titulo: string, texto:string): Observable<any> {
      const data: FormData = new FormData();
      data.append("id", id);
      data.append("titulo_observaciones", titulo);
      data.append("observaciones", texto);
                     
    const postRequest = new HttpRequest('POST', environment.api + 'api/paquete/updateObservaciones',  data, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(postRequest);
  } 



  insertarImagen(id: string, nivel: string, obj: any): Observable<any> {
    var list = [];
    var objeto: any;
    if(obj.imagenes !== null && obj.imagenes !== undefined)
      objeto = obj.imagenes;
    else if(obj.imagenesItinerario !== null && obj.imagenesItinerario !== undefined)
      objeto = obj.imagenesItinerario;
    else if(obj.imagenesExcursion !== null && obj.imagenesExcursion !== undefined)
      objeto = obj.imagenesExcursion;
    
    for (let i in objeto){
      var imagen = {
        nivel: nivel,
        ext: objeto[i].ext,
        imagen: objeto[i].url,
      }
      list.push(imagen);
    }
    const data = {
      id_paquete: id,
      imagenes: list,
    }
    
    const postRequest = new HttpRequest('POST', environment.api + 'api/imagen/create', data, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(postRequest);
  } 

  insertarItinerario(id: string, obj: any): Observable<any> {
    var list = [];
    
    for (let i in obj.actividades){
      var actividad = {
        dia: obj.actividades[i].dia,
        actividad: obj.actividades[i].descripcion,
      }
      list.push(actividad);
    }
    const data = {
      id_paquete: id,
      actividades: list,
    }
    const postRequest = new HttpRequest('POST', environment.api + 'api/itinerario/create', data, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(postRequest);

  }

  insertarExcursionOpcional(id: string, obj: any): Observable<any> {
    var list = [];
    
    for (let i in obj.excursiones){
      var excursion = {
        titulo: obj.excursiones[i].nombre,       
      }
      list.push(excursion);
    }
    const data = {
      id_paquete: id,
      excursiones: list,
    }
    const postRequest = new HttpRequest('POST', environment.api + 'api/itinerario/createExcursiones', data, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(postRequest);

  }
  insertarHotel(nombre: string, categoria:string, tipoCama: any, imagen?:any): Observable<any> {
    var simple = '0';
    var doble = '0';
    for (let i in tipoCama){
      if(tipoCama[i] == "1"){
        simple = '1'
      } else { doble = '1' }
    }

    const data: FormData = new FormData();
    data.append("nombre", nombre);
    data.append("categoria", categoria);
    data.append("simple", simple);
    data.append("doble", doble);
    //data.append("imagen", imagen);
                
    
  const postRequest = new HttpRequest('POST', environment.api + 'api/hotel/create',  data, { 
    headers: this.httpHeaders,
    reportProgress: true,
  });
  return this.http.request(postRequest);
} 
insertarHabitaciones(id_hotel: string, list: any): Observable<any> {
  const data = {
      id_hotel: id_hotel,
      habitaciones: list,
    }

    const postRequest = new HttpRequest('POST', environment.api + 'api/habitacion/createHabitaciones',  data, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
} 

  getAsientosInic(tipo:string): Observable<any> {
    const data: FormData = new FormData();
      data.append("tipo", tipo);
                     
    const postRequest = new HttpRequest('POST', environment.api + 'api/tipoTransporte/get',  data, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  }
  getTransporte(id:string): Observable<any> {
    const data: FormData = new FormData();
    data.append("id", id);
                     
    const postRequest = new HttpRequest('POST', environment.api + 'api/tipoTransporte/getById',  data, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });
    
    return this.http.request(postRequest);

  }

  getTipoTransporte(): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/tipoTransporte/index',  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);

  }
  getTipoHabitacion(): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/tipoHabitacion/index',  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  }
  getTipoCama(): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/tipoCama/index',  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  }
  getPaquete(id: string): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/paquete/get?id='+id,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  }
  //get itinerario
  getItinerario(id: string): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/itinerario/list?id_paquete='+id,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  }
  getImagenes(id: string, tipo: string):Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/imagen/list?id_paquete='+id+'&tipo='+tipo,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  }
  getExcursionesItinerario(id: string): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/itinerario/listExcursiones?id_paquete='+id,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest); 
  }
  deleteImagen(id: string): Observable<any> {                          
    const postRequest = new HttpRequest('GET', environment.api + 'api/imagen/deleteImage?id='+id,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest); 
  }
  deleteItinerario(data): Observable<any> {   
                     
    const postRequest = new HttpRequest('POST', environment.api + 'api/itinerario/deleteActividades', data,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest); 
  }
  deleteExcursionesItinerario(data): Observable<any> {                          
    const postRequest = new HttpRequest('POST', environment.api + 'api/itinerario/deleteExcursiones', data,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest); 
  }

  //get excursiones
  getExcursiones(id: string): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/excursion/list?id_paquete='+id,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest); 
  }

  insertarExcursion(id: string, obj: any): Observable<any> {
    var list = [];
    
    for (let i in obj.excursiones){
      var excursion = {
        titulo: obj.excursiones[i].titulo,
        descripcion: obj.excursiones[i].descripcion,
        imagen: obj.excursiones[i].imagen.localUrl,
        ext: obj.excursiones[i].imagen.ext,
      }
      list.push(excursion);
    }
    const data = {
      id_paquete: id,
      excursiones: list,
    }
    const postRequest = new HttpRequest('POST', environment.api + 'api/excursion/create', data, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(postRequest);

  }
  deleteExcursiones(data): Observable<any> {                          
    const postRequest = new HttpRequest('POST', environment.api + 'api/excursion/deleteExcursiones', data,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest); 
  }
//De modificar 
  get(id: string): Observable<any> {                          
    const postRequest = new HttpRequest('GET', environment.api + 'api/paquete/get?id='+id, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest); 
  }
  getHotel(id: string): Observable<any> {                          
    const postRequest = new HttpRequest('GET', environment.api + 'api/hotel/get?id='+id, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest); 
  } 
  updateHotel(id: string, nombre: string, categoria:string, tipoCama: any, imagen?:any): Observable<any> {
    var simple = '0';
    var doble = '0';
    for (let i in tipoCama){
      if(tipoCama[i] == "1"){
        simple = '1'
      } else { doble = '1' }
    }

    const data: FormData = new FormData();
    data.append("id", id);
    data.append("nombre", nombre);
    data.append("categoria", categoria);
    data.append("simple", simple);
    data.append("doble", doble);
    ///data.append("imagen", imagen);
                   
    
    const postRequest = new HttpRequest('POST', environment.api + 'api/hotel/update',  data, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(postRequest);
  } 
  deleteHabitaciones(id_hotel: string): Observable<any> {                          
    const postRequest = new HttpRequest('GET', environment.api + 'api/habitacion/deleteHabitaciones?id_hotel='+id_hotel, { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest); 
  }
  //De admin viajes
  getViajes(estado: string, texto: string): Observable<any> {
    texto = texto.toLowerCase();
    const meses=['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

    const data: FormData = new FormData();
    data.append("search", texto);
     
    if(estado !== 'all') data.append("estado", estado);
           

    if(meses.includes(texto)){
      const getRequest = new HttpRequest('POST', environment.api + 'api/paquete/listByMes',data, { 
        headers: this.httpHeaders,
        reportProgress: true,
      });
      return this.http.request(getRequest);  
    }
    else {
      const getRequest = new HttpRequest('POST', environment.api + 'api/paquete/search',data, { 
        headers: this.httpHeaders,
        reportProgress: true,
      });  
      return this.http.request(getRequest);
    }      
    
  }
  cancelarViaje(id: string): Observable<any> { 
    const data: FormData = new FormData();
    data.append("estado", "2"); 
    data.append("id", id);       

    const postRequest = new HttpRequest('POST', environment.api + 'api/paquete/change', data,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest); 
  }
  getPaquetesTop(): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/paquete/paquetesTop',  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  }

  getDataReservacion(id: string): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/reservacion/mostrarResumenReservacion?id='+id,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  }

  getCodeReservacion(id: string): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/reservacion/getCode?id='+id,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  }
  getCantidadReservacion(id: string): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/reservacion/getCantidadReservaciones?paquete='+id,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  }
  deletePaquete(id: string): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/paquete/delete?id='+id,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  }

  tieneItinerario(id: string): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/paquete/hasItinerario?id='+id,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  }

  tieneExcursiones(id: string): Observable<any> {                        
    const postRequest = new HttpRequest('GET', environment.api + 'api/paquete/hasExcursiones?id='+id,  { 
      headers: this.httpHeaders,
      reportProgress: true,
    });    
    return this.http.request(postRequest);
  }






}
